
import Component from "vue-class-component";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";

import {
    AddVtsCenterPracticeRequest,
    factory, PracticesClient,
    VtsCenterPracticeActions,
} from "@/api-client";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import VtsCenterPracticeUpsertForm from "@/features/documents/practices/components/VtsCenterPracticeUpsertForm.vue";
import {PracticeAddBase} from "@/features/documents/practices/views/PracticeAddBase";

interface Props {
    seafarerId: string;
    actions: VtsCenterPracticeActions;
}

@Component({
    components: {
        FormLayout,
        VtsCenterPracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<AddVtsCenterPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        Promise.all([
            new PracticesClient().availableVtsCenterActions()
        ]).then(values => {
            props.actions = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class AddVtsCenterPractice extends PracticeAddBase<AddVtsCenterPracticeRequest> implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: VtsCenterPracticeActions;

    model: AddVtsCenterPracticeRequest = factory.create(AddVtsCenterPracticeRequest);

    async submitPractice() {
        return await this.submit(this.model);
    }

    getDefaultReturnRouteName(): string {
        return "vts-center-practice-details";
    }
}
